// BUG_REPORTER — TEMPORARY FEATURE. Delete this folder per docs/BUG_REPORTER.md.
//
// A report's status, through the one StatusBadge (docs/DESIGN.md: every status
// goes through it — this page used to keep its own colour map). The label is the
// plain-English one the reporter reads. The tone is stated here because the
// badge's classifier reads words like "pending", and "Reported" or "Being fixed"
// are not among them.

import React from 'react';
import StatusBadge from '../../components/StatusBadge';
import type { Tone } from '../../components/ui/tokens';
import { BUG_STATUS_LABEL, type BugStatus } from '../../lib/bugReportApi';

const TONE_BY_STATUS: Record<BugStatus, Tone> = {
  open: 'neutral',
  triaged: 'attention',
  in_progress: 'attention',
  fixed: 'positive',
  wont_fix: 'neutral',
};

export const BugStatusBadge: React.FC<{ status: BugStatus; className?: string }> = ({ status, className }) => (
  <StatusBadge status={BUG_STATUS_LABEL[status]} tone={TONE_BY_STATUS[status]} className={className} />
);
